const MenuLovFields = [
    {
        name: '节点名称',
        code: 'nodeName',
        column: true,
        defaultFilter: true
    },
    {
        name: '菜单路径',
        code: 'path',
        column: true,
        defaultFilter: true
    }
]
export default MenuLovFields;